/**
 * Debounce a given function by a provided amount of time
 *
 * @param {Function} func - function to be called
 * @param {Number} wait - amount of time before function called
 * @param {Boolean} immediate - value that determines if function should be called immediately
 */

export default function debounce(func, wait, immediate) {
  let timeout;
  return function debounceFn(...args) {
    const context = this;
    const later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
